<template>
  <div id="func-10">
    <funcionalidade-header :titulo="tituloNavegacao"/>
    <div class="main">
      <SolicitacaoListagemGeral
        :funcionalidade="funcionalidade"
        :rota-detalhe="rotaDetalhe"
        :rota-historico="rotaHistorico"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoListagemGeral from '@/components/TemplateSolicitacao/SolicitacaoListagemGeral'

export default {
  components: { SolicitacaoListagemGeral, FuncionalidadeHeader },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('Login', ['user', 'contratos']),
    ...mapGetters('SetupApp', ['configuracaoAcesso']),
    tituloNavegacao () {
      return this.configuracaoAcesso.meusProtocolos.parametros.textos.tituloCabecalho
    },
    rotaHistorico () {
      return `/49/historico`
    },
    rotaDetalhe () {
      return `/49/detalhe`
    }
  },
  methods: {
    async init () {
    }
  },
  created () {
    this.init()
  }
}
</script>
<style
  lang="less"
  scoped
>
#func-10 {
  .sub {
    font-size: 11px;
    color: #555555;
    margin: 0;
    font-weight: 400;
  }

  .main {
    margin-top: 30px;
    padding: 0 15px 20px;
  }

  .listagem-extrato-reembolso {
    border-left: 5px solid var(--situacao-cor);
    border-radius: 6px;
  }

  .situacao-card {
    color: var(--situacao-cor)
  }
}
</style>
